import React, { useEffect, useState } from 'react'
import { ButtonNormal } from '../../../components/buttons/button-normal'
import { ButtonReinterpret } from '../../../components/buttons/button-reinterpret'
import { DataType } from '../../../interfaces/utils'
import {GetPersonalidad, copyResponse, getZodiac, isEmpty, formatSignAndAge} from '../../../utils/functions'
import { useDispatch, useSelector } from 'react-redux'
import { interpret } from './functions'
import { GetConsult, ResetConsult } from '../../../store/actions'
import { Dispatch } from 'redux'
import { Zodiaco, ZodiacoType } from '../../../data/zodiaco'
import { useNavigate } from 'react-router-dom'
import { NombreTarotista } from '../../../data/personality'
import PersonalitySelector from '../../../components/personality-selector'

const Compatibilidad = () => {
    const navigate = useNavigate()
    const [showResponse, setShowResponse] = useState<boolean>(false)
    const [response, setResponse] = useState('')
    const dispatch: Dispatch<any> = useDispatch()
    const { user, consult, loading } = useSelector((state: any) => state)
    const [data, setData] = useState<DataType>({
        consultante: {
            name: '',
            date: '',
            zodiac: '',
            phone: '',
            personality: '',
        },
        consultado: {
            name: '',
            date: '',
            zodiac: '',
            personality: '',
        },
        consulta: '',
    })
    const [status, setStatus] = useState({
        isDone: false,
        isConsulting: false,
        isInterpret: false,
    })
    const zodiaco: ZodiacoType[] = Zodiaco
    const [personalidad, setPersonalidad] = useState<NombreTarotista>()

    const handleZodiacConsultant = (date: string): void => {
        let zodiac = getZodiac(date)
        let personality = GetPersonalidad(date)
        setData({
            ...data,
            consultante: {
                ...data.consultante,
                zodiac,
                date,
                personality,
            },
        })
    }

    const handleZodiacThird = (date: string): void => {
        let zodiac = getZodiac(date)
        let personality = GetPersonalidad(date)
        setData({
            ...data,
            consultado: {
                ...data.consultado,
                zodiac,
                date,
                personality,
            },
        })
    }

    const handleInputConsultant = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (event.target.name === 'date' && parseInt(event.target.value.slice(0, 4)) > 1900) {
            handleZodiacConsultant(event.target.value)
        } else {
            setData({
                ...data,
                consultante: {
                    ...data.consultante,
                    [event.target.name]: event.target.value,
                },
            })
        }
    }

    const handleInputThird = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (event.target.name === 'date' && parseInt(event.target.value.slice(0, 4)) > 1900) {
            handleZodiacThird(event.target.value)
        } else {
            setData({
                ...data,
                consultado: {
                    ...data.consultado,
                    [event.target.name]: event.target.value,
                },
            })
        }
    }

    // MANEJA LOS ESTADOS
    const handleStatus = (name: string, value: boolean): void => {
        setStatus({
            ...status,
            [name]: value,
        })
    }

    const interpretar = () => {
        handleStatus('isConsulting', true)
        const info = interpret(data, user.username, personalidad!, 'compatibilidad')
        dispatch(GetConsult(info))
        //handleStatus('isConsulting', false)
        //setShowResponse(true)
    }

    useEffect(() => {
        const saved = localStorage.getItem('personality')
        if (Object.entries(user).length === 0 || isEmpty(saved)) {
            navigate('/')
            return
        }
        setPersonalidad(saved as NombreTarotista)

        // Evita que la lectura previa (p. ej. Amor) se muestre como si fuera compatibilidad
        dispatch(ResetConsult())

        setStatus({
            isConsulting: false,
            isInterpret: false,
            isDone: false,
        })
        setShowResponse(false)
        setResponse('')

        const name_consultante = localStorage.getItem('name_consultante')
        if (name_consultante) {
            const date_consultante = localStorage.getItem('date_consultante') || ''
            const date_consultado = localStorage.getItem('date_consultado') || ''
            setData({
                consultante: {
                    name: name_consultante,
                    date: date_consultante,
                    zodiac: localStorage.getItem('zodiac_consultante') || '',
                    phone: localStorage.getItem('phone_consultante') || '',
                    personality: date_consultante ? GetPersonalidad(date_consultante) : '',
                },
                consultado: {
                    name: localStorage.getItem('name_consultado') || '',
                    date: date_consultado,
                    zodiac: localStorage.getItem('zodiac_consultado') || '',
                    personality: date_consultado ? GetPersonalidad(date_consultado) : '',
                },
                consulta: '',
            })

            localStorage.removeItem('name_consultante')
            localStorage.removeItem('date_consultante')
            localStorage.removeItem('zodiac_consultante')
            localStorage.removeItem('phone_consultante')
            localStorage.removeItem('name_consultado')
            localStorage.removeItem('date_consultado')
            localStorage.removeItem('zodiac_consultado')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- inicialización solo al montar
    }, [])

    useEffect(() => {
        if (Object.entries(user).length === 0) {
            navigate('/')
        }
    }, [user, navigate])

    useEffect(() => {
        if (showResponse) {
            let signoConsultante = document.getElementById('consultante')
            if (signoConsultante && data.consultante.zodiac.length > 0) {
                let description = zodiaco.filter((signo) => signo.name === data.consultante.zodiac)
                signoConsultante.innerHTML = description[0].description
            }
            if (data.consultado.zodiac.length > 0) {
                let signoTercero = document.getElementById('tercero')
                if (signoTercero) {
                    let description = zodiaco.filter((signo) => signo.name === data.consultado.zodiac)
                    signoTercero.innerHTML = description[0].description
                }
            }
        }
    }, [showResponse, data, zodiaco])

    useEffect(() => {
        // Solo reaccionar a una consulta de este tipo (no arrastrar Amor u otra tirada)
        if (isEmpty(consult) || consult.type !== 'compatibilidad') return

        if (!loading) {
            setStatus((s) => ({
                ...s,
                isConsulting: false,
                isInterpret: true,
            }))
            setResponse(consult.response)
            setShowResponse(true)
        } else {
            setResponse(consult.response)
            setShowResponse(true)
        }
    }, [consult, loading])

    // LIMPIA LOS ESTADOS PARA ATENDER UN NUEVO CLIENTE
    const nuevoCliente = () => {
        setResponse('')
        setStatus({
            ...status,
            isDone: false,
            isInterpret: false,
        })
        setData({
            consultante: {
                name: '',
                date: '',
                zodiac: '',
                phone: '',
                personality: '',
            },
            consultado: {
                name: '',
                date: '',
                zodiac: '',
                personality: '',
            },
            consulta: '',
        })
        setShowResponse(false)
    }

    // MANEJA LA SELECCION DE PERSONALIDADES
    const handlePersonalitySelector = (id: NombreTarotista) => {
        localStorage.setItem('personality', id)
        setPersonalidad(id)
    }

    return (
        <div className="relative w-full bg-no-repeat bg-cover mini:min-h-screen mini:h-full xl:h-height-main bg-comp mini:px-2 md:px-4 mini:pb-10 xl:pb-0">
            <p className="w-full py-5 italic font-bold text-center text-white mini:text-xl xl:text-4xl">
                Compatibilidad de Dos Personas
            </p>
            <div className="flex w-full mini:flex-col xl:flex-row">
                {/* left */}
                <div className="flex flex-col h-full gap-6 rounded-lg mini:w-full xl:w-1/2 bg-violetLight/70 mini:px-2 mini:py-5 md:p-5 shadow-card-horizontal">
                    <div className="flex flex-col gap-3">
                        <div className="flex gap-3 mini:flex-col md:flex-row">
                            <input
                                name="name"
                                type="text"
                                value={data.consultante.name}
                                onChange={(e) => handleInputConsultant(e)}
                                placeholder="Nombre del Consultante"
                                className="h-10 pl-3 text-base text-gray-400 rounded-lg mini:w-full md:w-1/2 focus-visible:outline-none focus-visible:border-violetDark focus-visible:border-2"
                                autoFocus={true}
                            />
                        <div className="flex gap-3">
                            <input
                                type="date"
                                name="date"
                                value={data.consultante.date}
                                onChange={(e) => handleInputConsultant(e)}
                                placeholder="Nacimiento"
                                className="w-1/2 pl-3 text-base text-gray-400 rounded-lg pr-1lh-10 focus-visible:outline-none focus-visible:border-violetDark focus-visible:border-2"
                            />
                            <input
                                type="text"
                                name="zodiac"
                                value={formatSignAndAge(data.consultante.zodiac, data.consultante.date)}
                                readOnly={true}
                                className="w-1/2 h-10 px-3 text-base text-gray-400 rounded-lg disabled:bg-white"
                                disabled={true}
                            />
                        </div>
                    </div>
                    </div>
                    <div className="flex gap-3 mini:flex-col md:flex-row">
                        <input
                            name="name"
                            type="text"
                            value={data.consultado.name}
                            onChange={(e) => handleInputThird(e)}
                            placeholder="Nombre del Consultado"
                            className="h-10 pl-3 text-gray-400 rounded-lg mini:w-full md:w-1/2 textr-base focus-visible:outline-none focus-visible:border-violetDark focus-visible:border-2"
                        />
                        <div className="flex gap-3">
                            <input
                                type="date"
                                name="date"
                                value={data.consultado.date}
                                onChange={(e) => handleInputThird(e)}
                                placeholder="Nacimiento"
                                className="w-1/2 h-10 pl-3 pr-1 text-gray-400 rounded-lg textr-base focus-visible:outline-none focus-visible:border-violetDark focus-visible:border-2"
                            />
                            <input
                                type="text"
                                name="zodiac"
                                value={formatSignAndAge(data.consultado.zodiac, data.consultado.date)}
                                readOnly={true}
                                className="w-1/2 h-10 px-3 text-gray-400 rounded-lg textr-base disabled:bg-white"
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="flex flex-wrap justify-center gap-3 disabled:hidden">
                        <ButtonNormal
                            caption="Hecho"
                            onClick={() => handleStatus('isDone', true)}
                            disabled={
                                status.isDone ||
                                data.consultante.name.length === 0 ||
                                data.consultante.zodiac.length === 0 ||
                                data.consultado.name.length === 0 ||
                                data.consultado.zodiac.length === 0
                            }
                        />
                        <ButtonNormal
                            caption={status.isConsulting ? 'Interpretando' : 'Interpretar'}
                            onClick={() => interpretar()}
                            disabled={status.isInterpret || !status.isDone}
                            loading={loading}
                        />
                        <ButtonReinterpret
                            isConsulting={status.isConsulting}
                            onConfirm={() => interpretar()}
                            disabled={!status.isInterpret}
                            loading={loading}
                        />
                        <ButtonNormal
                            caption="Ver Respuesta"
                            onClick={() => setShowResponse(true)}
                            disabled={response?.length === 0}
                        />
                    </div>
                </div>
                {showResponse ? (
                    <div className="absolute w-[90vw] h-[90vh] top-[2%] left-[5%] bg-zinc-200 shadow-2xl flex flex-row gap-5 rounded-xl mini:px-2 mini:py-5 md:p-5">
                        <div className="flex flex-col gap-3 mini:w-full xl:w-2/3">
                            <textarea
                                className="w-full h-full rounded-lg resize-none mini:p-1 md:p-5"
                                value={response}
                                onChange={(e) => setResponse(e.target.value)}
                            />
                            <div className="flex flex-row flex-wrap justify-center gap-1">
                                <ButtonNormal
                                    caption="Volver"
                                    onClick={() => setShowResponse(false)}
                                    disabled={loading}
                                />
                                <ButtonNormal
                                    caption="Copiar Respuesta"
                                    onClick={() => copyResponse(response)}
                                    disabled={loading}
                                />
                                <ButtonNormal caption="Nuevo Cliente" onClick={() => nuevoCliente()} />
                                <ButtonNormal
                                    caption="Generando"
                                    loading={loading}
                                    disabled={!loading}
                                    onClick={() => {}}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-1/3 gap-3 mini:hidden xl:block">
                            <p className="font-semibold">Consultante: {data.consultante.zodiac}</p>
                            <div
                                className="w-full p-5 overflow-y-auto text-sm rounded-lg bg-zinc-50"
                                id="consultante"
                            ></div>
                        </div>
                    </div>
                ) : null}
            </div>
            <PersonalitySelector selected={personalidad} onChange={handlePersonalitySelector} />
        </div>
    )
}

export default Compatibilidad
